// Keeps PrimeVue tooltips inside the viewport horizontally.
//
// PrimeVue centres a top/bottom tooltip over its target and does not nudge it
// back when it runs off the edge of the screen. The promotion / pricing-terms
// badges sit at the corners of the card, so on narrow (mobile) viewports the
// centred tooltip gets clipped against the left or right edge.
//
// We watch for tooltips being appended to the document and, once PrimeVue has
// positioned them, shift them inwards so they stay on screen — moving the arrow
// by the same amount so it keeps pointing at the badge.

const MARGIN = 8; // px gap kept between the tooltip and the screen edge

function clamp(tooltip: HTMLElement) {
    const rect = tooltip.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;

    let shift = 0;
    if (rect.left < MARGIN) {
        shift = MARGIN - rect.left;
    } else if (rect.right > vw - MARGIN) {
        shift = vw - MARGIN - rect.right;
    }

    if (!shift) return;

    const left = parseFloat(tooltip.style.left || "0");
    tooltip.style.left = `${left + shift}px`;

    // Only top/bottom tooltips have a horizontally-centred arrow worth nudging.
    const isVerticalArrow =
        tooltip.classList.contains("p-tooltip-top") ||
        tooltip.classList.contains("p-tooltip-bottom");

    if (!isVerticalArrow) return;

    const arrow = tooltip.querySelector<HTMLElement>(".p-tooltip-arrow");
    if (!arrow) return;

    const marginLeft = parseFloat(getComputedStyle(arrow).marginLeft || "0");
    arrow.style.marginLeft = `${marginLeft - shift}px`;
}

export function initTooltipViewportClamp() {
    if (typeof window === "undefined" || !("MutationObserver" in window)) return;

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            mutation.addedNodes.forEach((node) => {
                if (
                    node instanceof HTMLElement &&
                    node.classList.contains("p-tooltip")
                ) {
                    // Defer until PrimeVue has finished aligning the tooltip.
                    requestAnimationFrame(() => clamp(node));
                }
            });
        }
    });

    observer.observe(document.body, { childList: true });
}
